import React, { useEffect } from 'react';
import { Button } from 'antd';
import { AkamProFooterIcon, CloseXIcon, EmptyHeartIcon, UnlimitedIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { useAppDispatch, useAppSelector } from 'store';

import { startTimer } from 'modules/blok-test';
import { closeHeartModal, globalConst, useCountdownTimer, useGetHeartData } from 'modules/global';

import { Modal } from 'components';

const HeartFinishModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { locale = 'uz' } = useRouter();
  const { heartData, refetch } = useGetHeartData();
  const isOpen = useAppSelector(state => state.heartModal.isOpen);
  const t = globalConst.extraTranslation.heart_modal[locale as 'uz' | 'ru'];
  const { remaining, isFinished } = useCountdownTimer({
    startTime: heartData?.heart_spent_at,
    countdownAmount: heartData?.time_left,
    unit: 'hour'
  });

  const onClose = () => {
    dispatch(closeHeartModal());
  };

  useEffect(() => {
    if (heartData?.heart_spent_at) {
      dispatch(startTimer());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [heartData?.heart_spent_at]);

  useEffect(() => {
    if (isFinished) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinished]);

  return (
    <Modal
      zIndex={99999}
      footer={false}
      open={isOpen}
      centered
      onClose={onClose}
      width="380px"
      closeIcon={
        <div className="flex items-center justify-center rounded-full bg-gray-800 p-1">
          <CloseXIcon size="12" />
        </div>
      }
      styles={{
        content: { padding: '16px', borderRadius: '12px' }
      }}
      title={<span className="text-lg">{t?.yurak_tugadi}</span>}
    >
      <div className="my-2 text-center text-base font-semibold text-gray-500">
        {heartData?.heart_spent_at && (
          <>
            <span className="mr-1 text-red-500">{remaining}</span>
            {t?.keyin_yurak_toladi?.toLocaleLowerCase()}
          </>
        )}
      </div>

      <div>
        <Link href={globalConst.pageNames.PRO} onClick={onClose}>
          <div className="mb-2 flex w-full cursor-pointer items-center justify-between rounded-xl bg-[linear-gradient(135deg,_#00F260_0%,_#0575E6_100%)] p-3.5 text-white shadow-[0px_4px_0px_0px_#136C7F] transition">
            <div className="flex items-center gap-2">
              <EmptyHeartIcon size="24" />
              <AkamProFooterIcon size="90" />
            </div>
            <UnlimitedIcon />
          </div>
        </Link>

        {/* <div className="h-50 flex w-1/2 cursor-pointer flex-col items-center justify-center gap-y-3 rounded-xl bg-gray-100 p-3.5 text-center font-medium shadow-[0px_4px_0px_0px_#E4E4E4]">
          <div className="self-center">
            <HeartIcon size="60" />
          </div>
          <div>
            <p className="text-base">{t('reklama_korish')}</p>
          </div>
          <div className="flex items-center gap-1">
            <VideoPlayIcon />
            <span className="text-gray-400">+1</span>
          </div>
        </div> */}
      </div>

      <Link href={globalConst.pageNames.PRO} onClick={onClose}>
        <Button className="!py-5.5 my-3 !w-full !rounded-xl !border-none !bg-green-500 !px-8 !font-medium !text-white hover:!bg-green-600 hover:!text-white">
          {t?.sotib_olish}
        </Button>
      </Link>
      <Button
        onClick={onClose}
        className="!py-5.5 !w-full !rounded-xl !border-none !bg-gray-100 !px-8 !font-medium hover:!bg-gray-200 hover:!text-black"
      >
        {t?.keyinroq}
      </Button>
    </Modal>
  );
};

export default HeartFinishModal;
